<template>
  <!-- 能源类型 -->
  <span class="apphome">
    <div class="apphome_box">
      <span style="margin-bottom:12px;display:flex;">
        <el-button type="primary" @click="addMenu" style="margin-right:40px">新增顶级菜单<i
            class="el-icon-document-add"></i></el-button>
        <el-input placeholder="请输入菜单名称" v-model="searchName" style="width:20%"></el-input>
        <el-button type="primary" icon="el-icon-search" style="margin-left:20px" @click="search_fn">搜索</el-button>
        <!-- <span style="font-size:18px">已选中菜单（{{deviceName}}）</span> -->
      </span>
      <el-table id="demo" max-height="800"
        :header-cell-style="{ color: '#333', fontFamily: 'MicrosoftYaHeiUI', fontSize: '14px', fontWeight: 900, backgroundColor: '#f5f7fa'}"
        stripe :data="tableData" border style="width: 100%" row-key="id"
        :tree-props="{children: 'next', hasChildren: 'hasChildren'}">
        <template slot="empty">
          <span class="noData">
            <img src="../../assets/noData.png" alt="暂无数据">
            <span class="text">暂无数据</span>
          </span>
        </template>
        <el-table-column type="index" label="#" width="50" align="center">
        </el-table-column>
        <el-table-column label="名称" align="left" min-width="150">

          <template slot-scope="{row}">
            <el-link type="primary" :class="{'actived':mainId===row.id}" @click="tempclick(row)">{{ row.rightname }}
              <!-- <el-link type="primary" :class="{'actived':mainId===row.Id}" @click="tempclick(row.Id)">{{ row.Name }} -->
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="图形文件" align="center" min-width="150">
          <template slot-scope="{row}">
            <img v-if="row.iconFile" :src="'./static/image/科技蓝/menu/'+row.iconFile + '.png'" class="avatar"
              style="position: relative;left: 50%;transform: translateX(-50%);">
          </template>
        </el-table-column>
        <el-table-column label="路由" align="center" width="200">
          <template slot-scope="{row}">
            {{ row.webpage || '模块' }}
          </template>
        </el-table-column>
        <el-table-column label="描述" align="center" min-width="150">
          <template slot-scope="{row}">
            {{ row.memo }}
          </template>
        </el-table-column>
        <!-- <el-table-column v-for="(item,index) in columns" :key='index' :prop="item.key" :label="item.name" :align="item.al"
        :minWidth="item.width">
        <template slot-scope="{row}">{{ row.typeName }}
        </template>
      </el-table-column> -->
        <el-table-column label="操作" align="center" width="500">
          <template #default="{row}">
            <!-- <el-button type="primary"  @click="addMenu(row)">添加同级菜单
            </el-button> -->
            <el-button type="primary" @click="addMenuChild(row)">添加子级菜单
            </el-button>
            <el-button type="success" @click="editMenu(row)">编辑</el-button>
            <el-popconfirm title="这是一段内容确定删除吗？" @onConfirm="deleteMenu(row)">
              <template #reference>
                <el-button type="danger" style="margin-left:10px  ">删除</el-button>
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <!-- 新增修改 -->
      <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :close-on-click-modal='false' :visible.sync="dialogVisible"
        width="400" center>
        <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
          <!-- <span style="font-size:18px">已选中菜单（{{deviceName}}）</span> -->
          <el-form-item label="菜单名称:" prop="rightname">
            <el-input v-model="temp.rightname"></el-input>
          </el-form-item>
          <el-form-item label="菜单路径:" prop="webpage">
            <el-input v-model="temp.webpage"></el-input>
          </el-form-item>

          <el-form-item label="图形文件:" prop="iconFile">
            <!-- <el-input v-model="temp.iconFile" type="text"  v-if="dialogStatus == 'edit'" disabled></el-input>
           <el-button type="primary" size="small">切换图片</el-button>
          <el-input v-model="temp.iconFile" type="file"  v-if="dialogStatus != 'edit'"></el-input> -->
            <el-upload class="avatar-uploader" action="http://localhost:8080/" :show-file-list="false"
              :before-upload="beforeAvatarUpload">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否有子菜单:" prop="hasSonMenu">
            <el-radio v-model="radioValue" label="0">无</el-radio>
            <el-radio v-model="radioValue" label="1">有</el-radio>
          </el-form-item>
          <el-form-item label="描述:" prop="memo">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" placeholder="请输入内容"
              v-model="temp.memo"></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogStatus==='edit'?edit_fn('temp'):add_fn('temp')">确 定
            </el-button>
          </span>
        </template>
      </el-dialog>

    </div>
  </span>
</template>
<script>

  //  import {} from "../../api/energySubType";
  import menuApi from '@/components/api/menuApi.js'
  import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
  import userManagerStore from '@/page/userManager/userManagerStore.js'
  export default {
    components: {
      nomalInputDialog,
    },
    data () {
      return {
        searchName: "",
        imageUrl: '',
        imgIconFile: "",
        radioValue: "0",
        tableData: [],
        tableDataCopy: [],
        NowUnit: {},
        mainId: "",
        nowMenu: "",
        deviceName: "",
        temp: {},
        dialogVisible: false,
        dialogStatus: 'add',
        textMap: {
          add: "新增web顶级菜单",
          addSon: "新增子级菜单",
          edit: "修改web菜单"
        },
        rules: {
          rightname: [
            {required: true,message: '请输入菜单名称',trigger: 'blur'}
          ],


        },
      };
    },
    computed: {


    },
    watch: {
      dialogVisible (val) {
        if(!val) {
          this.imageUrl=''
          this.imgIconFile=""
        }
      },
      searchName (val) {
        if(val=='') {
          this.tableData=this.tableDataCopy
        }
      },
    },
    mounted () {
      this.NowUnit=this.$store.unitStore.getters.getNowUnit
      this.getList();//获取列表数据 

    },
    methods: {
      // handleAvatarSuccess(res, file) {
      //   this.imageUrl = URL.createObjectURL(file.raw);
      // },
      //图片选择
      beforeAvatarUpload (file) {
        const isJPG=file.type==='image/jpeg';
        const isLt2M=file.size/1024/1024<2;
        var fileName=file.name
        this.imgIconFile=fileName.slice(0,fileName.length-4)
        this.imageUrl="./static/image/科技蓝/menu/"+file.name

        return isJPG&&isLt2M;
      },
      //搜索列表
      search_fn () {
        // this.tableData = []
        var data=JSON.parse(JSON.stringify(this.tableDataCopy))
        var arr=[]
        var searchName=this.searchName
        var recursiveFunction=function() {
          const getStr=function(list) {
            list.forEach(function(row) {
              if(row.next.length!=0) {
                if(row.rightname.includes(searchName)) {
                  arr.push(row)
                }
                getStr(row.next)
              } else {

                if(row.rightname.includes(searchName)) {
                  arr.push(row)
                }

              }
            })
          }
          getStr(data)
        }
        recursiveFunction()
        arr.forEach(item => item.next=[])
        this.tableData=arr
      },
      //弹出绑定设备
      tempclick (v) {
        this.mainId=v.id;
        this.nowMenu=v
        this.deviceName=v.rightname
        // this.getDevice()
        // if (this.$refs.child) {
        //   this.$refs.child.childMethod(this.mainId);
        // }
      },
      //添加顶级菜单（新）
      addMenu () {
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};
      },
      // 确认添加
      add_fn (formName) {
        this.$refs[formName].validate(valid => {
          if(valid) {

            if(this.dialogStatus=='add') {
              this.$api.menuApi.saveMenuAdd(this.temp.rightname,"appright",'1',this.temp.webpage,"1","1",this.radioValue,this.imgIconFile,respon => {
                // this.$dialogMethod.showMessage("添加成功!")
                this.$message({message: "添加成功",type: 'success'});
                //刷新页面
                this.getList()
                this.dialogVisible=false
              },respon => {
                err(respon)
              })
            } else {
              var parentid=this.nowMenu.id //当前选中web菜单的id
              var serialno=this.nowMenu.serialno+1
              // this.$api.menuApi.saveMenu("", item.rightname,

              this.$api.menuApi.saveMenuSon(this.temp.rightname,
                "appright",serialno,this.temp.webpage,parentid,"1","1",this.radioValue,this.imgIconFile,respon => {
                  // console.log("respon",respon);
                  // this.$dialogMethod.showMessage("添加成功!")
                  this.$message({message: "添加成功",type: 'success'});
                  //刷新页面
                  this.getList()
                  this.dialogVisible=false
                },respon => {
                  // console.log("respon",respon);
                  err(respon)
                  this.$message({message: respon,type: 'error'});
                })
            }

          } else {
            return false;
          }
        });
      },
      //添加顶级菜单（旧）
      // addMenu() {
      // 	if(this.nowMenu == "") {
      // 		this.$dialogMethod.showMessage("请先选同级菜单!")
      // 		return
      // 	}
      // 	var parentid = "" //当前选中web菜单的父级id
      // 	if(undefined != this.nowMenu.parentid) {
      // 		parentid = this.nowMenu.parentid
      // 	}
      // 	var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
      // 	dialog.open('添加web菜单', [{
      // 		name: '菜单名称',
      // 		pkid: 'rightname'
      // 	}, {
      // 		name: '菜单路径',
      // 		pkid: 'webpage'
      // 	}], item => {
      // 		if(item.rightname == undefined){
      // 			this.$message({ showClose: true, message: '请输入菜单名称', type: 'warning'});
      // 			return
      // 		}
      // 		//添加接口
      // 		//var serialno = isempty(this.nextItem) ? this.nowMenu.serialno + 1 : (this.nowMenu.serialno + this.nextItem.serialno) / 2
      // 		var serialno = this.nowMenu.serialno + 1
      // 		this.$api.menuApi.saveMenuAdd(item.rightname, "appright", serialno, item.webpage, parentid,"1","1", respon => {
      // 			// this.$dialogMethod.showMessage("添加成功!")
      // 			 this.$message({message:"添加成功" ,type: 'success'});
      // 			//刷新页面
      // 			this.getList()
      // 		}, respon => {
      // 			err(respon)
      // 		})
      // 	})
      // },
      //添加子菜单
      addMenuChild (nowMenu) {
        this.dialogStatus='addSon';
        if(nowMenu.hasSonMenu==0) {
          this.$message({message: '请先把 '+nowMenu.rightname+' 修改成有子菜单',type: 'warning'});
          return
        }
        this.dialogVisible=true;
        this.nowMenu=nowMenu
        this.textMap.addSon='新增子级菜单（'+nowMenu.rightname+'）'
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};

      },
      //修改
      editMenu (v) {
        this.dialogStatus='edit';
        this.dialogVisible=true;
        this.nowMenu=v
        this.radioValue=v.hasSonMenu.toFixed(0)
        this.imgIconFile=v.iconFile
        if(v.iconFile) {
          this.imageUrl="./static/image/科技蓝/menu/"+v.iconFile+".png"
        } else {
          this.imageUrl=""
        }

        this.temp=Object.assign({},v);
        //  this.textMap.edit = '修改web菜单（'+v.rightname+'）'
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });


      },
      //确定修改
      edit_fn () {
        this.$refs['temp'].validate(valid => {
          if(valid) {
            //修改接口
            this.$api.menuApi.saveMenu(this.nowMenu.id,this.temp.rightname,
              this.nowMenu.righttype,this.nowMenu.serialno,this.temp.webpage,this.nowMenu.parentid,"1","1",this.radioValue,this.imgIconFile,respon => {
                // this.$dialogMethod.showMessage("修改成功!")
                this.$message({message: "修改成功",type: 'success'});
                //刷新页面
                this.getList()
                this.dialogVisible=false;
                this.$store.menuStore.commit("getMenuList")
              },respon => {
                err(respon)
                this.$message({message: respon,type: 'error'});
              })
          } else {
            return false;
          }
        });

      },
      //删除
      deleteMenu (nowMenu) {
        var id=nowMenu.id //当前选中web菜单的id
        //删除接口
        this.$api.menuApi.deleteMenuById(id,respon => {
          // this.$dialogMethod.showMessage(respon)
          this.$message({message: respon,type: 'success'});
          // this.nowMenu = undefined
          this.getList()
          this.$store.menuStore.commit("getMenuList")
        },respon => {
          err(respon)
          this.$message({message: respon,type: 'error'});
        })

      },

      //获取列表数据
      getList () {
        menuApi.getAllRight(this.$store.userStore.state.nowUserInfo.userId,res => {
          // console.log("res",res);
          this.tableData=res.appRight
          this.tableDataCopy=res.appRight
        })
        userManagerStore.commit('getAllRightCopy',this.$store.userStore.state.nowUserInfo.userId)
        // menuApi.getMenu("appright", true, respon => {
        // 			this.tableData = respon
        // })




      },


    }
  };
</script>
<style lang="scss">
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }

  .avatar {
    width: 150px;
    min-width: 50px;
    height: 150px;
    min-height: 50px;
    display: block;
  }

  .select_tree {
    .el-tree-node {
      .is-leaf+.el-checkbox .el-checkbox__inner {
        display: inline-block;
      }

      .el-checkbox__input>.el-checkbox__inner {
        display: none;
      }
    }

  }
</style>
<style lang="scss" scoped>
  .apphome {
    padding: 15px;
  }

  .actived {
    color: red;
  }

  .apphome_box {
    background-color: #fff;
    padding: 20px;
    min-height: calc(100vh - 130px);
    max-height: calc(100vh - 130px);
    position: relative;
  }

  .avatar {
    width: 30px;
    height: 30px;
    object-fit: cover;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .wrapper {
    width: 100%;
    height: 500px;
  }

  .pagination_box {
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
  }
</style>